import { trackEvent } from "@pb/utils/tracking";
// BOSS = broken out size selector
export const trackOnView = (sizeGuideResults, oldSizeGuideResults, productId, articleName, isBossPDP, isFutureCommerceData) => {
    if (((sizeGuideResults === null || sizeGuideResults === void 0 ? void 0 : sizeGuideResults.length) && Object.keys(sizeGuideResults[0]).length) ||
        (oldSizeGuideResults && Object.keys(oldSizeGuideResults).length)) {
        if (isFutureCommerceData) {
            trackEvent({
                event_name: 'click_on_size_guide',
                event_type: 'size_guide_click',
                dep_variable_name: ['size_selector_version'],
                dep_variable_format: ['string'],
                size_selector_version: isBossPDP ? 'broken_out' : 'dropdown',
                event_id: 'click on size guide link in the Broken Out Size Selector area',
            });
        }
        else {
            trackEvent({
                event_name: 'click_on_size_guide',
                event_type: 'size_guide_click',
                dep_variable_name: ['size_selector_version'],
                dep_variable_format: ['string'],
                size_selector_version: isBossPDP ? 'broken_out' : 'dropdown',
                event_id: 'click on size guide',
            });
        }
    }
    else {
        trackEvent({
            event_name: 'no size guide page shown',
            event_type: 'size_guide_fallback_shown',
            dep_variable_name: ['size_selector_version'],
            dep_variable_format: ['string'],
            size_selector_version: isBossPDP ? 'broken_out' : 'dropdown',
            event_id: 'no size guide page shown',
        });
    }
};
export const trackOnSizeGuideClose = (isBossPDP) => {
    trackEvent({
        event_name: 'click on size guide close button',
        event_type: 'size_guide_close',
        dep_variable_name: ['size_selector_version'],
        dep_variable_format: ['string'],
        size_selector_version: isBossPDP ? 'broken_out' : 'dropdown',
        event_id: 'click on size guide close button',
    });
};
export const trackOnClickMeasurement = (isAccordionExpanded, isBossPDP) => {
    if (isAccordionExpanded) {
        trackEvent({
            event_name: 'how to measure expand',
            event_type: 'size_guide_measure_expand',
            dep_variable_name: ['size_selector_version'],
            dep_variable_format: ['string'],
            size_selector_version: isBossPDP ? 'broken_out' : 'dropdown',
            event_id: 'Click on how to measure accordion',
        });
    }
    else {
        trackEvent({
            event_name: 'how to measure collapse',
            event_type: 'size_guide_measure_collapse',
            dep_variable_name: ['size_selector_version'],
            dep_variable_format: ['string'],
            size_selector_version: isBossPDP ? 'broken_out' : 'dropdown',
            event_id: 'Click on how to measure accordion',
        });
    }
};
export const trackOnSizeGuideType = (isBossPDP) => {
    trackEvent({
        event_name: 'click on size guide type',
        event_type: 'size_guide_click_guide_type',
        dep_variable_name: ['size_selector_version'],
        dep_variable_format: ['string'],
        size_selector_version: isBossPDP ? 'broken_out' : 'dropdown',
        event_id: 'click on size guide type on the size guide overlay',
    });
};
export const trackOnSizeGuideRange = (isBossPDP) => {
    trackEvent({
        event_name: 'click on size range selector button',
        event_type: 'size_guide_size_range_buttons_click',
        dep_variable_name: ['size_selector_version'],
        dep_variable_format: ['string'],
        size_selector_version: isBossPDP ? 'broken_out' : 'dropdown',
        event_id: 'click on size range buttons on the size guide overlay',
    });
};
//# sourceMappingURL=tracking.js.map